import React from 'react';
import { Star, LogOut, User } from '../../icons';
import Menu from '../ui/Menu';

const getInitials = (name) => {
  if (!name) return 'U';
  const names = name.trim().split(/\s+/);
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

/**
 * Avatar button with an account menu. Used in the mobile header.
 */
const UserProfile = ({ userDisplayName, userEmail, favoriteCount, onSignOut }) => (
  <Menu
    label="Account"
    align="right"
    trigger={
      <span className="flex items-center gap-2 h-11 pl-2 pr-1 rounded-xl hover:bg-white/5">
        {typeof favoriteCount === 'number' && (
          <span className="hidden sm:inline-flex items-center gap-1 text-sm text-secondary tabular">
            <Star className="w-4 h-4 text-amber" filled />
            {favoriteCount}
          </span>
        )}
        <span className="w-9 h-9 rounded-full bg-accent-soft text-accent flex items-center justify-center text-xs font-semibold">
          {getInitials(userDisplayName)}
        </span>
      </span>
    }
    items={[
      { label: userDisplayName || 'Account', icon: User, disabled: true },
      userEmail ? { label: userEmail, disabled: true } : null,
      { label: 'Sign out', icon: LogOut, danger: true, onSelect: onSignOut },
    ]}
  />
);

export default UserProfile;
